import { LoggerService } from '../services/logger.service';
import { pascalToKebab } from '../services/utils/utilities';

/**
 * Provee metodos para imprimir en consola anteponiendo el nombre de la clase
 */
export class Logger {

  /**
   * Atributo para nombrar la clase
   */
  public name: string;

  constructor(name?: string) {
    if (typeof name === 'string') {
      this.name = name;
    } else {
      this.name = pascalToKebab(this.constructor.name);
    }
  }

  /**
   * Imprime un mensaje
   * @param message mensaje
   * @param args argumentos extras para imprimir
   */
  protected log(message: string, ...args: any[]) {
    LoggerService.log(`[${this.name}] - ${message}`, args);
  }

  /**
   * Imprime un mensaje en contexto de alerta
   * @param message mensaje
   * @param args argumentos extras para imprimir
   */
  protected warn(message: string, ...args: any[]) {
    LoggerService.warn(`[${this.name}] - ${message}`, args);
  }

  /**
   * Imprime un mensaje en contexto de error
   * @param message mensaje
   * @param args argumentos extras para imprimir
   */
  protected error(message: string, ...args: any[]) {
    LoggerService.error(`[${this.name}] - ${message}`, args);
  }

  /**
   * Imprime un mensaje en contexto de info
   * @param message mensaje
   * @param args argumentos extras para imprimir
   */
  protected info(message: string, ...args: any[]) {
    LoggerService.info(`[${this.name}] - ${message}`, args);
  }
}
